export default __webpack_public_path__ + "static/media/img-0115-canada-premium-face.9a202277.png";